/**
 * Centralized API Endpoint Definitions
 * All API paths are defined here to avoid hardcoding in repositories.
 */

export const ENDPOINTS = {
  AGENTS: {
    BASE: '/agents',
    BY_ID: (agentId) => `/agents/${agentId}`,
    DUPLICATE: (agentId) => `/agents/${agentId}/duplicate`,
    WIDGET: (agentId) => `/agents/${agentId}/widget`,
    AVATAR: (agentId) => `/agents/${agentId}/avatar`,
    LINK: (agentId) => `/agents/${agentId}/link`,
    KNOWLEDGE_BASE_SIZE: (agentId) => `/agents/${agentId}/knowledge-base/size`,
  },

  VOICES: {
    BASE: '/voices',
    BY_ID: (voiceId) => `/voices/${voiceId}`,
    SIMILAR: '/voices/similar-voices',
    EDIT: (voiceId) => `/voices/${voiceId}/edit`,
  },

  CONVERSATIONS: {
    BASE: '/conversations',
    BY_ID: (conversationId) => `/conversations/${conversationId}`,
    AUDIO: (conversationId) => `/conversations/${conversationId}/audio`,
    TOKEN: '/conversations/token',
    SIGNED_URL: '/conversations/get-signed-url',
  },

  TTS: {
    SPEECH: (voiceId) => `/text-to-speech/${voiceId}`,
    STREAM: (voiceId) => `/text-to-speech/${voiceId}/stream`,
  },

  KNOWLEDGE_BASE: {
    BASE: '/knowledge-base',
    URL: '/knowledge-base/url',
    TEXT: '/knowledge-base/text',
    RAG_INDEX: '/knowledge-base/rag-index',
    BY_ID: (docId) => `/knowledge-base/${docId}`,
    DOCUMENT_RAG: (docId) => `/knowledge-base/${docId}/rag-index`,
    DOCUMENT_RAG_BY_ID: (docId, ragId) => `/knowledge-base/${docId}/rag-index/${ragId}`,
    DEPENDENT_AGENTS: (docId) => `/knowledge-base/${docId}/dependent-agents`,
    CONTENT: (docId) => `/knowledge-base/${docId}/content`,
    CHUNK: (docId, chunkId) => `/knowledge-base/${docId}/chunk/${chunkId}`,
  },

  DASHBOARD: {
    ANALYTICS: '/dashboard/analytics',
    SUBSCRIPTION: '/dashboard/subscription',
    SETTINGS: '/dashboard/settings',
  },

  TOOLS: {
    BASE: '/tools',
    BY_ID: (toolId) => `/tools/${toolId}`,
    DEPENDENT_AGENTS: (toolId) => `/tools/${toolId}/dependent-agents`,
  },

  USAGE: {
    CHARACTER_STATS: '/usage/character-stats',
  },

  PHONE_NUMBERS: {
    BASE: '/phone-numbers',
    BY_ID: (phoneNumberId) => `/phone-numbers/${phoneNumberId}`,
  },

  LIVEKIT: {
    TOKEN: '/livekit/token',
  },
};
